export const MODALS = Object.freeze({
  signup: {
    name: 'signup',
    component: 'Signup'
  },
  predictionFilters: {
    name: 'predictionFilters',
    component: 'PredictionFilters'
  },
  pilScoreExplained: {
    name: 'pilScoreExplained',
    component: 'PilScoreExplained'
  }
});

export type ModalName = keyof typeof MODALS;
